const sanityConfig = () => ({
    projectId: "4swbd7aj",
    dataset: process.env.GATSBY_SANITY_DATASET,
});

export default sanityConfig;
